$.fn.marquee = function (i, individual) {

	var e = $(this);
	var t = $('<span>');
	var textContent = e.text().split(",").filter(function(x) { return x != null && x != "" });
	var d = 0;
	
	if (individual) {

		e.text('').append(t);

		if (textContent.length >= 1) {			
			textContent.forEach(function (item) {
				var childTag = $("<span class='duplicate'>").text(item);
				childTag.appendTo(t)
			});
		}

	} else {
		t.text(e.text());				
		e.text('').append(t);
	}

	//If header hanner scroller, increase time multiplier for smaller screens
	if (e.parents(".banner-hero").length) {

		console.log("Width:" + t.width());

		if (window.innerWidth <= 767) {
			d = 0.032 * t.width() + 's';
		} else if (window.innerWidth >= 768 && window.innerWidth <= 1279) {
			d = 0.016 * t.width() + 's';
		} else {
			d = 0.016 * t.width() + 's';
		}

	} else {
		d = 0.016 * t.width() + 's';
	}

	t.css('animation-duration', d);
	for (i = 0; i < 4; i++) {
		t.clone().appendTo(e);
	}


	e.addClass("ready")
}